import "../../assets/css/floating-modal.css";
import { forwardRef, useImperativeHandle, useRef } from "react";

if (!window.globalActiveModals) {
  window.globalActiveModals = {};
}

const FloatingModal = forwardRef((props, ref) => {
  const containersRef = useRef([]);
  const wsConnectionsRef = useRef({});
  const modalStatesRef = useRef({});

  // function detectOS() {
  //   if (navigator.userAgentData?.platform) {
  //     const platform = navigator.userAgentData.platform.toLowerCase();

  //     if (platform.includes("win")) return "Windows";
  //     if (platform.includes("mac")) return "macOS";
  //     if (platform.includes("linux")) return "Linux";
  //   }

  //   return "unknown";
  // }

  const createModal = (title, agentId, userId, userMessage = "") => {
    console.log("🚀 ~ createModal ~ uuid:", agentId);
    if (window.globalActiveModals[agentId]) {
      console.log(`Modal with uuid ${agentId} is already open`);
      return;
    }

    // const currentOs = detectOS();
    const micButton = "Alt";

    if (
      typeof window.modalleftOffsetCounter === "undefined" ||
      isNaN(window.modalleftOffsetCounter)
    ) {
      window.modalleftOffsetCounter = 687;
    }

    const leftOffset = Number(window.modalleftOffsetCounter);
    window.modalleftOffsetCounter = leftOffset + 20;

    modalStatesRef.current[agentId] = {
      itemId: null,
      ws: null,
      isMuted: true,
      unmutePressed: false,
      isSpeechRequired: false,
      audioStream: null,
      mediaRecorder: null,
      recognition: null,
      audioBuffer: [],
      isRecognitionActive: false,
      finalTranscript: "",
      baseTranscript: "",
      lastProcessedTranscript: "",
      recognitionStartTime: null,
      userMessage: userMessage ?? "",
      audioQueue: [],
      isPlayingAudio: false,
      audioContext: null,
      audioUnlocked: false,
    };

    const container = document.createElement("div");
    container.className = `modal-${agentId}`;
    document.body.appendChild(container);

    const contentNode = document.createElement("div");
    contentNode.style.padding = "0";
    contentNode.style.fontSize = "1rem";
    contentNode.style.height = "100%";
    contentNode.style.display = "flex";
    contentNode.style.flexDirection = "column";

    const style = document.createElement("style");
    style.textContent = `
      .modal-${agentId} #zx9k_auth-div-${agentId} {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
        position: relative;
      }

      .modal-${agentId} .zx9k_agent-message {
        align-self: flex-start;
        background-color: #f0f0f0;
        border-top-left-radius: 5px;
        color: black;
        word-break: break-word;
        overflow-wrap: break-word;
      }

      .modal-${agentId} .zx9k_user-message {
        align-self: flex-end;
        background-color: #162f4b;
        color: white;
        border-top-right-radius: 5px;
      }
  
      .modal-${agentId} .zx9k_chat-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        width: 100%;
      }

      .modal-${agentId} #zx9k_chat-messages-${agentId} {
        flex: 1;
        padding: 15px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: #f8f9fa;
      }

      .modal-${agentId} #zx9k_chat-messages-${agentId}::-webkit-scrollbar {
        width: 6px;
      }

      .modal-${agentId} #zx9k_chat-messages-${agentId}::-webkit-scrollbar-thumb {
        background-color: #c5c5c5;
        border-radius: 4px;
      }

      .modal-${agentId} .zx9k_chat-message {
        display: inline-block;
        padding: 10px 14px;
        border-radius: 15px;
        margin: 6px 0;
        max-width: 75%;
        word-wrap: break-word;
        font-size: 14px;
      }

      .modal-${agentId} .zx9k_chat-message.user {
        align-self: flex-end;
        background: #162f4b;
        color: #ffffffff;
        border-bottom-right-radius: 5px;
      }

      .modal-${agentId} .zx9k_chat-message.bot {
        align-self: flex-start;
        background: #edf2f7;
        color: #333;
        border-bottom-left-radius: 5px;
      }

      .modal-${agentId} .zx9k_chat-input {
        display: flex;
        align-items: flex-end;
        gap: 10px;
        padding: 10px;
        border-top: 1px solid #ddd;
        background: #fff;
        position: sticky;
        bottom: 0;
        width: 100%;
        flex-shrink: 0;
        position: relative; 
      }
        
      .modal-${agentId} .zx9k_message {
        max-width: 80%;
        padding: 12px 15px;
        border-radius: 18px;
        font-size: 14px;
        line-height: 1.4;
        position: relative;
      }

      .modal-${agentId} .zx9k_message .zx9k_time {
        font-size: 11px;
        color: #161616ad;
        margin-top: 5px;
        text-align: right;
      }

      .modal-${agentId} .zx9k_input-wrapper {
        flex: 1;
        position: relative;
        display: flex;
        align-items: flex-end;
      }

      .modal-${agentId} #zx9k_chat-input-${agentId} {
        flex: 1;
        padding: 10px 15px;
        padding-right: 140px;
        border-radius: 20px;
        border: 1px solid #ccc;
        font-size: 14px;
        color: #0e0e0eff;
        background: #f9f9f9;
        outline: none;
        max-height: 100px; 
        overflow-y: auto;
        resize: none;
        font-family: inherit;
        line-height: 1.4;
        min-height: calc(1.4rem * 3 + 20px); 
        width: 100%; 
      }

      .modal-${agentId} #zx9k_chat-input-${agentId}::-webkit-scrollbar {
        width: 6px;
      }

      .modal-${agentId} #zx9k_chat-input-${agentId}::-webkit-scrollbar-thumb {
        background-color: #c5c5c5;
        border-radius: 4px;
      }

      .modal-${agentId} #zx9k_chat-input-${agentId}:focus {
        border-color: #162f4b;
        box-shadow: 0 0 0 2px rgba(3, 210, 247, 0.2);
      }

      @media (max-width: 600px) {
          #zx9k_chat-input-${agentId} {
            min-height: calc(1.4rem * 4 + 20px); 
          }
        }

      .modal-${agentId} .zx9k_button-container {
        position: absolute;
        bottom: 5px; 
        right: 5px; 
        display: flex;
        gap: 5px;
        align-items: flex-end;
      }

      .modal-${agentId} #zx9k_chat-send-button-${agentId},
      .modal-${agentId} #zx9k_mute-btn-${agentId},
      .modal-${agentId} #zx9k_speaker-btn-${agentId},
      .modal-${agentId} #zx9k_spinner-${agentId}{
        background: #162f4b;
        border: none;
        border-radius: 50%;
        width: 38px; 
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }

      .modal-${agentId} #zx9k_speaker-btn-${agentId}.muted .volume-waves {
        display: none;
      }

      .modal-${agentId} #zx9k_chat-send-button-${agentId}:hover,
      .modal-${agentId} #zx9k_speaker-btn-${agentId}:hover,
      .modal-${agentId} #zx9k_mute-btn-${agentId}:hover {
        background: #0d1c2d;
      }

      .modal-${agentId} #zx9k_mute-btn-${agentId}.recording {
        background: #ff4444;
        animation: pulse-${agentId} 1.5s infinite;
      }

      @keyframes pulse-${agentId} {
        0%, 100% {
          box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.7);
        }
        50% {
          box-shadow: 0 0 0 10px rgba(255, 68, 68, 0);
        }
      }

      .modal-${agentId} #zx9k_mute-btn-${agentId} img {
        width: 20px;
        height: 20px;
        object-fit: contain;
        user-select: none;
        pointer-events: none;
      }

      .modal-${agentId} .zx9k_thinking {
        display: flex;
        gap: 4px;
        padding: 6px 10px;
        background: #f1f1f1;
        border-radius: 12px;
        width: fit-content;
      }

      .modal-${agentId} .zx9k_thinking .dot {
        width: 8px;
        height: 8px;
        background-color: #555;
        border-radius: 50%;
        display: inline-block;
        animation: blink-${agentId} 1.4s infinite both;
      }

      .modal-${agentId} .zx9k_thinking .dot:nth-child(2) {
        animation-delay: 0.2s;
      }
      .modal-${agentId} .zx9k_thinking .dot:nth-child(3) {
        animation-delay: 0.4s;
      }

      @keyframes blink-${agentId} {
        0%,
        80%,
        100% {
          opacity: 0.2;
        }
        40% {
          opacity: 1;
        }
      }
    `;

    contentNode.classList.add("custom-modal-content");
    contentNode.innerHTML = `
      <div id="zx9k_auth-div-${agentId}">
        <div class="zx9k_chat-container">
          <div class="zx9k_chat-messages" id="zx9k_chat-messages-${agentId}"></div>
          <div class="zx9k_chat-input">
            <div class="zx9k_input-wrapper">
              <textarea 
                class="zx9k_input-field" 
                id="zx9k_chat-input-${agentId}" 
                placeholder="Type a message..." 
                autocomplete="off"
                rows="3" ></textarea>
              <div class="zx9k_button-container"> 
                <button id="zx9k_mute-btn-${agentId}">
                  <img src="/assets/img/icons/mic-off.png" alt="Mute/Unmute" />
                </button>
                <button id="zx9k_speaker-btn-${agentId}" title="Toggle AI Audio Response" class="muted">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7bdff2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <path class="volume-waves" d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                    <line class="mute-slash" x1="1" y1="23" x2="23" y2="1" style="display:block;"></line>
                  </svg>
                </button>
                <button id="zx9k_chat-send-button-${agentId}">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#7bdff2" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z"/>
                  </svg>
                </button>
                <button id="zx9k_spinner-${agentId}" style="display:none">
                  <img src="/assets/img/icons/spinner.svg" alt="spinner" style="width:20px; filter:invert(1);" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    contentNode.prepend(style);

    const modal = window.Modal(container, {
      draggable: true,
      title,
      width: Math.min(window.innerWidth - 40, 480),
      height: Math.min(window.innerHeight - 40, 480),
      position: "center",
      closable: true,
      minimizable: true,
      maximizable: true,
      content: contentNode,
      responsive: true,
      resizable: true,
      onload: () => {
        const modalEl = document.querySelector(`.modal-${agentId}`);
        if (!modalEl) return;

        const modals = document.getElementsByClassName("lm-modal");

        const positionEl = modals[modals.length - 1];
        if (!positionEl) return;

        positionEl.style.left = `${leftOffset}px`;

        const titleEl = modalEl.querySelector(".lm-modal-title");
        if (!titleEl) return;
        const children = Array.from(titleEl.children);
        const titleDiv = children[1];
        titleDiv.classList.add("lm-title-truncated");

        const state = modalStatesRef.current[agentId];

        const initializeAudioEngine = async () => {
          if (!state.audioContext) {
            state.audioContext = new (
              window.AudioContext || window.webkitAudioContext
            )();
          }
          if (state.audioContext.state === "suspended") {
            await state.audioContext.resume();
          }
          state.audioUnlocked = true;
        };

        async function playNextAudio() {
          if (state.audioQueue.length === 0) {
            state.isPlayingAudio = false;
            return;
          }

          state.isPlayingAudio = true;
          const audioBlob = state.audioQueue.shift();

          try {
            await initializeAudioEngine();
            const arrayBuffer = await audioBlob.arrayBuffer();
            const audioBuffer =
              await state.audioContext.decodeAudioData(arrayBuffer);

            const source = state.audioContext.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(state.audioContext.destination);

            source.onended = () => playNextAudio();
            source.start(0);
          } catch (error) {
            console.warn(
              "Web Audio API decode failed, attempting fallback:",
              error,
            );
            const audioUrl = URL.createObjectURL(audioBlob);
            const audio = new Audio(audioUrl);
            audio.onended = () => {
              URL.revokeObjectURL(audioUrl);
              playNextAudio();
            };
            audio.onerror = () => {
              URL.revokeObjectURL(audioUrl);
              playNextAudio();
            };
            audio.play().catch((e) => {
              URL.revokeObjectURL(audioUrl);
              playNextAudio();
            });
          }
        }

        function addMessage(content, isUser = false) {
          const chatMessages = document.getElementById(
            `zx9k_chat-messages-${agentId}`,
          );
          if (!chatMessages) return;

          const messageDiv = document.createElement("div");
          messageDiv.className = `zx9k_message ${
            isUser ? "zx9k_user-message" : "zx9k_agent-message"
          }`;

          const contentDiv = document.createElement("div");

          const urlRegex = /(https?:\/\/[^\s]+)/gi;
          const parts = content.split(urlRegex);

          parts.forEach((part) => {
            if (urlRegex.test(part)) {
              const cleanUrl = part.replace(/[),.]+$/g, "");
              const leftover = part.slice(cleanUrl.length);

              const link = document.createElement("a");
              link.href = cleanUrl;
              link.textContent = cleanUrl;
              link.target = "_blank";
              link.rel = "noopener noreferrer";
              link.style.setProperty("color", "#007BFF", "important");
              link.style.textDecoration = "underline";
              contentDiv.appendChild(link);

              if (leftover) {
                const span = document.createElement("span");
                span.textContent = leftover;
                contentDiv.appendChild(span);
              }
            } else {
              const formattedPart = part
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/\n/g, "<br>")
                .replace(/\s\s/g, "&nbsp;&nbsp;");
              const span = document.createElement("span");
              span.innerHTML = formattedPart;
              contentDiv.appendChild(span);
            }
          });

          messageDiv.appendChild(contentDiv);
          chatMessages.appendChild(messageDiv);
          chatMessages.scrollTop = chatMessages.scrollHeight;
        }

        function showThinkingAnimation() {
          const chatMessages = document.getElementById(
            `zx9k_chat-messages-${agentId}`,
          );
          if (!chatMessages) return;

          const thinkingDiv = document.createElement("div");
          thinkingDiv.className =
            "zx9k_message zx9k_agent-message zx9k_thinking";
          thinkingDiv.innerHTML = `
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>`;
          chatMessages.appendChild(thinkingDiv);
          chatMessages.scrollTop = chatMessages.scrollHeight;
        }

        function removeThinkingAnimation() {
          const modalEl = document.querySelector(`.modal-${agentId}`);
          if (!modalEl) return;

          const thinkingDiv = modalEl.querySelector(
            ".zx9k_message.zx9k_agent-message.zx9k_thinking",
          );
          if (thinkingDiv) thinkingDiv.remove();
        }

        function initializeWebSocket() {
          try {
            if (wsConnectionsRef.current[agentId]) {
              const existingWs = wsConnectionsRef.current[agentId];
              if (
                existingWs.readyState === WebSocket.OPEN ||
                existingWs.readyState === WebSocket.CONNECTING
              ) {
                existingWs.close();
              }
            }

            const url = process.env.REACT_APP_WSS_URL;
            if (!url) {
              console.error("WebSocket URL is not defined in .env");
              return;
            }

            const ws = new WebSocket(url);
            wsConnectionsRef.current[agentId] = ws;
            state.ws = ws;

            ws.onopen = () => {
              if (ws.readyState === WebSocket.OPEN) {
                ws.send(
                  JSON.stringify({
                    type: "metadata",
                    agentId: agentId,
                    userId: userId,
                    isSpeechRequired: state.isSpeechRequired,
                  }),
                );
              }
              const inputEl = document.getElementById(
                `zx9k_chat-input-${agentId}`,
              );
              if (inputEl && state.userMessage && !inputEl.value) {
                inputEl.value = state.userMessage;
                inputEl.focus();
              }
            };

            ws.onmessage = async (event) => {
              if (event.data instanceof Blob) {
                if (state.isSpeechRequired) {
                  state.audioQueue.push(event.data);
                  if (!state.isPlayingAudio) {
                    playNextAudio();
                  }
                }
                return;
              }

              try {
                const data = JSON.parse(event.data);

                document.getElementById(
                  `zx9k_spinner-${agentId}`,
                ).style.display = "none";
                document.getElementById(
                  `zx9k_speaker-btn-${agentId}`,
                ).style.display = "";
                document.getElementById(
                  `zx9k_mute-btn-${agentId}`,
                ).style.display = "";
                document.getElementById(
                  `zx9k_chat-send-button-${agentId}`,
                ).style.display = "";

                if (data.type === "ConversationText" && data.message) {
                  const { role, content, from } = data.message;
                  if (from && from === "transcriber") {
                    chatInput.value += (chatInput.value ? " " : "") + content;
                    return;
                  }
                  addMessage(content, role === "user");
                  if (role === "assistant") removeThinkingAnimation();
                }
              } catch (e) {
                console.error("Failed to parse websocket message", e);
              }
            };

            ws.onerror = (e) => {
              console.error("WebSocket error for modal:", agentId, e);
            };
          } catch (error) {
            console.error("WebSocket initialization failed:", error);
          }
        }

        initializeWebSocket();

        const chatInput = contentNode.querySelector(
          `#zx9k_chat-input-${agentId}`,
        );
        const sendButton = contentNode.querySelector(
          `#zx9k_chat-send-button-${agentId}`,
        );
        const chatMessages = contentNode.querySelector(
          `#zx9k_chat-messages-${agentId}`,
        );
        const muteBtn = contentNode.querySelector(`#zx9k_mute-btn-${agentId}`);
        const speakerBtn = contentNode.querySelector(
          `#zx9k_speaker-btn-${agentId}`,
        );
        const muteImg = muteBtn.querySelector("img");

        speakerBtn.addEventListener("click", () => {
          state.isSpeechRequired = !state.isSpeechRequired;
          const slash = speakerBtn.querySelector(".mute-slash");

          if (state.isSpeechRequired) {
            speakerBtn.classList.remove("muted");
            slash.style.display = "none";
          } else {
            speakerBtn.classList.add("muted");
            slash.style.display = "block";
            state.audioQueue = [];
          }
        });

        const appendMessage = (text, type = "user") => {
          const msg = document.createElement("div");
          msg.className = `zx9k_chat-message ${type}`;
          msg.textContent = text;
          chatMessages.appendChild(msg);
          chatMessages.scrollTop = chatMessages.scrollHeight;
        };

        const handleSend = () => {
          initializeAudioEngine();
          const text = chatInput.value.trim();
          const currentWs = wsConnectionsRef.current[agentId];

          if (!text || !currentWs || currentWs.readyState !== WebSocket.OPEN) {
            console.warn("Cannot send message - WebSocket not ready");
            return;
          }

          appendMessage(text, "user");
          showThinkingAnimation();
          currentWs.send(
            JSON.stringify({
              type: "user_message",
              message: text,
              itemId: state.itemId,
              isSpeechRequired: state.isSpeechRequired,
            }),
          );

          chatInput.value = "";
          chatInput.focus();
          state.finalTranscript = "";
          state.baseTranscript = "";
          state.lastProcessedTranscript = "";
        };

        sendButton.onclick = handleSend;

        chatInput.addEventListener("keypress", (e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
          }
        });

        function startPulse() {
          muteBtn.classList.add("recording");
        }

        function stopPulse() {
          muteBtn.classList.remove("recording");
        }

        async function getMicrophoneStream() {
          if (
            state.audioStream &&
            state.audioStream.getTracks().some((t) => t.readyState === "live")
          ) {
            return state.audioStream;
          }
          state.audioStream = await navigator.mediaDevices.getUserMedia({
            audio: true,
          });
          return state.audioStream;
        }

        async function startAudioStreaming() {
          try {
            await initializeAudioEngine();
            const stream = await getMicrophoneStream();

            const mimeType = MediaRecorder.isTypeSupported(
              "audio/webm;codecs=opus",
            )
              ? "audio/webm;codecs=opus"
              : "audio/webm";

            state.mediaRecorder = new MediaRecorder(stream, {
              mimeType: mimeType,
            });

            state.audioBuffer = [];
            state.mimeType = mimeType;

            state.mediaRecorder.ondataavailable = (event) => {
              if (event.data.size > 0) {
                state.audioBuffer.push(event.data);
              }
            };

            state.mediaRecorder.start(100);
          } catch (err) {
            console.error("Mic access denied or streaming failed:", err);
          }
        }

        function stopAudioStreaming() {
          try {
            state.isRecognitionActive = false;
            state.recognitionStartTime = null;
            if (
              state.mediaRecorder &&
              state.mediaRecorder.state !== "inactive"
            ) {
              state.mediaRecorder.stop();
            }
            if (state.recognition) {
              state.recognition.stop();
            }
            state.recognition = null;
          } catch (err) {
            console.warn("Error stopping audio stream:", err);
          }
        }

        function applyMuteState(mute) {
          state.isMuted = mute;
          muteImg.src = state.isMuted
            ? "/assets/img/icons/mic-off.png"
            : "/assets/img/icons/mic.png";

          if (state.isMuted) {
            stopPulse();
          } else {
            startPulse();
          }
        }

        async function muteAndSendAudio() {
          state.unmutePressed = false;
          applyMuteState(true);

          const currentWs = wsConnectionsRef.current[agentId];

          try {
            if (
              state.mediaRecorder &&
              state.mediaRecorder.state !== "inactive"
            ) {
              await new Promise((resolve) => {
                state.mediaRecorder.onstop = () => resolve();
                try {
                  state.mediaRecorder.stop();
                } catch (e) {
                  resolve();
                }
                setTimeout(resolve, 1500);
              });
            }

            if (state.audioBuffer && state.audioBuffer.length > 0) {
              const mimeType = state.mediaRecorder?.mimeType || "audio/webm";

              const audioBlob = new Blob(state.audioBuffer, {
                type: mimeType,
              });

              if (
                currentWs &&
                currentWs.readyState === WebSocket.OPEN &&
                audioBlob.size > 0
              ) {
                document.getElementById(
                  `zx9k_spinner-${agentId}`,
                ).style.display = "";
                document.getElementById(
                  `zx9k_mute-btn-${agentId}`,
                ).style.display = "none";
                document.getElementById(
                  `zx9k_speaker-btn-${agentId}`,
                ).style.display = "none";
                document.getElementById(
                  `zx9k_chat-send-button-${agentId}`,
                ).style.display = "none";

                currentWs.send(audioBlob);
              }
              state.audioBuffer = [];
            }
          } catch (err) {
            console.error("Error while stopping/sending audio:", err);
          } finally {
            stopAudioStreaming();
            stopPulse();
          }
        }

        const handleKeyDown = (e) => {
          const activeElement = document.activeElement;
          const isThisModalActive =
            activeElement &&
            (activeElement.id === `zx9k_chat-input-${agentId}` ||
              modalEl.contains(activeElement));
          if (
            e.key === micButton &&
            !state.unmutePressed &&
            isThisModalActive
          ) {
            e.preventDefault();
            state.unmutePressed = true;
            applyMuteState(false);
            startAudioStreaming();
          }
        };

        const handleKeyUp = (e) => {
          if (e.key === micButton && state.unmutePressed) {
            muteAndSendAudio();
          }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);

        muteBtn.addEventListener("click", () => {
          if (!state.isMuted) {
            muteAndSendAudio();
          } else {
            state.unmutePressed = true;
            applyMuteState(false);
            startAudioStreaming();
          }
        });

        state.cleanup = () => {
          document.removeEventListener("keydown", handleKeyDown);
          document.removeEventListener("keyup", handleKeyUp);
        };
      },
      onclose: () => {
        const state = modalStatesRef.current[agentId];

        if (state) {
          state.isRecognitionActive = false;
          if (state.mediaRecorder && state.mediaRecorder.state !== "inactive")
            state.mediaRecorder.stop();

          if (state.audioStream)
            state.audioStream.getTracks().forEach((t) => t.stop());

          if (state.audioContext && state.audioContext.state !== "closed")
            state.audioContext.close();

          if (state.recognition) state.recognition.stop();
          if (state.cleanup) state.cleanup();
          state.audioQueue = [];
        }

        if (wsConnectionsRef.current[agentId]) {
          const ws = wsConnectionsRef.current[agentId];
          if (
            ws.readyState === WebSocket.OPEN ||
            ws.readyState === WebSocket.CONNECTING
          ) {
            ws.close();
          }
          delete wsConnectionsRef.current[agentId];
        }

        delete modalStatesRef.current[agentId];

        delete window.globalActiveModals[agentId];

        if (document.body.contains(container)) {
          document.body.removeChild(container);
        }
      },
    });

    window.globalActiveModals[agentId] = modal;
    containersRef.current.push(container);
  };

  useImperativeHandle(ref, () => ({
    open: (data) => {
      const displayName =
        data?.displayName ||
        data?.assistant?.platform?.name ||
        data?.assistant?.name ||
        "Assistant";

      const agentId = data?.agentId || data?.assistant?.uuid;
      const userId = data?.userId;
      const userMessage = data?.userMessage || "";

      if (!agentId || !userId) return;
      createModal(displayName, agentId, userId, userMessage);
    },
  }));

  return null;
});

export default FloatingModal;
